import { useEffect, useRef } from "react";

const DEFAULT_REFETCH_INTERVAL_MS = 5 * 60 * 1000;
const REFETCH_EVERY = Number(process.env.REACT_APP_REFETCH_INTERVAL_MS) || DEFAULT_REFETCH_INTERVAL_MS;

const Refetch = ({ refetch }) => {
  const timeoutRef = useRef(null);

  useEffect(() => {
    const doPeriodicRefetch = () => {
      timeoutRef.current = setTimeout(() => {
        refetch();
        doPeriodicRefetch();
      }, REFETCH_EVERY);
    };
    doPeriodicRefetch();
    return () => clearTimeout(timeoutRef.current);
  }, [refetch]);

  return null;
};

export default Refetch;
